import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
);

export const chatChartBaseOptions = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: {
      top: 10,
      right: 16,
      bottom: 8,
      left: 8,
    },
  },
  interaction: {
    mode: 'nearest' as const,
    intersect: false,
  },
    plugins: {
    legend: {
      display: true,
      position: 'bottom' as const,
      labels: {
        usePointStyle: true,
        pointStyle: 'circle' as const,
        boxWidth: 12,
        boxHeight: 12,
        padding: 20,
        font: {
          size: 11,
        },
      },
    },
    tooltip: {
      enabled: true,
      mode: 'index' as const,
      intersect: false,
    },
  },
  scales: {
    x: {
      ticks: { font: { size: 10 }, maxRotation: 45, minRotation: 0 },
      grid: { display: false },
    },
    y: {
      beginAtZero: true,
      grace: '5%',
      ticks: {
        padding: 8,
        font: {
          size: 11,
        },
      },
      grid: {
        color: 'rgba(0,0,0,0.06)',
      },
      border: {
        display: false,
      },
    },
  },
};